export default "__VITE_ASSET__fkxMlmw$__"